<template>
  <div
    class="form-html-content"
    v-html="content" />
</template>

<script setup>
  defineProps({
    content: String
  })
</script>

<style lang="scss" scoped>
  .form-html-content {
    display: block;

    @include body-xxs;

    line-height: 1.4;
  }
</style>
